/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow strict
 */

// invariant(condition, message) will refine types based on "condition", and
// if "condition" is false will throw an error. This function is special-cased
// in flow itself, so we can't name it anything else.
// export default function invariant(cond?: boolean, message?: string) {
//   throw new Error(
//     'Internal Lexical error: invariant() is meant to be replaced at compile ' +
//       'time. There is no runtime version.'
//   );
// }

export default function invariant(
  cond: boolean, 
  message?: string
): asserts cond {
  if (!cond) {
    throw new Error(
      message || 'Invariant violation: unexpected falsy value'
    );
  }
}